module.exports = __webpack_public_path__ + "img/ss.de6a1495.svg";